import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppRoutesEnum } from '../../../enums/app-routes.enum';
import { Store } from '@ngrx/store';
import * as AuthActions from '../../../auth/store/actions/auth.actions';
import { AuthService } from '../../servises/auth/auth.service';
import { LocalStorageKeys } from '../../../enums/local-storage-keys.enum';
import { BaseTokensResponse } from '../../../auth/store/models/auth-response.interface';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private _router: Router,
    private _store: Store,
    private _authService: AuthService,
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError((response: HttpResponse<any>) => {
          if (response instanceof HttpErrorResponse && response.status === 401) {
            const refreshToken = localStorage.getItem(LocalStorageKeys.RefreshToken);

            if (refreshToken) {
              return this._authService.refreshToken(refreshToken)
                .pipe(
                  switchMap((data: BaseTokensResponse) => {
                    const { access_token } = data;

                    this._store.dispatch(AuthActions.loginSuccess({
                      token: access_token,
                    }));
                    this._store.dispatch(AuthActions.parseToken({ token: access_token }));

                    return next.handle(this._addToken(req, access_token));
                  }),
                  catchError(() => {
                    this._redirectToLogin();
                    return of();
                  }),
                );
            } else {
              this._redirectToLogin();
            }
          }
          return throwError(() => response);
        }),
      );
  }

  private _addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`,
      },
    })
  }

  private _redirectToLogin(): void {
    this._store.dispatch(AuthActions.logout());
    this._router.navigate([AppRoutesEnum.Login]);
  }
}
